// extracted by mini-css-extract-plugin
module.exports = {"highlightClass":"DownloadComp_highlightClass__2nxBV","imgIconStyle":"DownloadComp_imgIconStyle__18l-P"};